<template>
    <div class="vtext">
        商品规格管理
    </div>
    <div class="viplist">
        <Noshu :disabled="loading" :lengths="infolists.length"></Noshu>

        <div class="pagechoose">

            显示结果：

            <div class="pagees">

                <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">

            </div>

        </div>
        <div class="vipt">
            <div class="screen">
                <el-cascader v-model="value" :options="options" placeholder="类型筛选:" @change="handleChange" />
            </div>
            <div class="search">
                <div style="width: 24px;height: 24px;text-align: center;">
                    <img style="width: 100%;height: 100%;" src="../../assets/secree.png" alt="">
                </div>
                <div>
                    <input type="text" placeholder="关键词搜索" v-model="keyseach" @keyup.enter="wordkey">
                </div>
            </div>

        </div>
        <div class="vipporpe" v-loading="loading">
            <table>
                <thead>
                    <tr>

                        <th style="width: 170px;">规格名称</th>
                        <th style="width: 173px;">规格属性</th>
                        <th style="width: 183px;">参数名称</th>
                        <th style="width: 160px;">关联产品（个）</th>

                        <th>操作</th>


                        <!-- <th class="states" style="width: 80px;">操作</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in infolists" :key="index" style="cursor: pointer;">

                        <td v-html="item.typeName">

                        </td>
                        <td>
                            {{ item.attributeName || '暂无' }}
                        </td>
                        <td>
                            {{ item.parameterName || '暂无' }}
                        </td>
                        <td>
                            {{ item.productTotal || '0' }}
                        </td>

                        <td @click.stop>
                            <div class="operate">
                                <div @click="gomessage(item, 1)">查看规格</div>
                                <div @click="gomessage(item, 2)">查看参数</div>
                                <div @click="namechange(item.id)">编辑名称</div>
                                <div @click="spec(item.id)">删除</div>

                            </div>

                        </td>


                    </tr>
                </tbody>
            </table>

            <div style=" height: 70px;"></div>



        </div>
        <div class="example-pagination-block" :style="{ 'display': wordKey.length >= 1 ? 'none' : '' }">
            <el-pagination background v-model:current-page="pageCount" layout="prev, pager, next" :pager-count="5"
                :page-count="total" @current-change="changepige" :disabled="loading" />
        </div>
        <div class="example-pagination-iskey" :style="{ 'display': wordKey.length >= 1 ? '' : 'none' }">
            <el-pagination background v-model:current-page="pageCount" layout="prev, pager, next" :pager-count="5"
                :page-count="9999999" @current-change="changepige" :disabled="loading" />
        </div>
    </div>

</template>

<script setup>
import { onMounted, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
// import Pagintion from '@/components/Pagination.vue'
import api from '@/api/api'
import Noshu from '@/components/Noshu.vue'
import { ElMessage, ElMessageBox } from 'element-plus'

let loading = ref(false)

let wordKey = ref('')
let keyseach = ref('')
let pageCount = ref(1)
const router = useRouter()
const infolists = ref([])
let startTime = ref('')
let endTime = ref('')
let total = ref(1)
let screenType = ref('0')
const value = ref([])
let sort = ref(false)

const options = reactive([
    {
        value: '0',
        label: '全部',
    },
    {
        value: '2',
        label: '规格类型',
    }
])
const namechange = (id) => {
    ElMessageBox.prompt('请输入新的规格名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern:
            /\S/,
        inputErrorMessage: '请输入规格名',
    })
        .then(({ value }) => {
            specTypeput(id, value)
        })
        .catch(() => {

        })
}
const specTypeput = async (goodsTypeId, specTypeName) => {
    let data = {
        goodsTypeId,
        specTypeName
    }
    const res = await api.specTypeput(data)

    if (res.success) {
        ElMessage({
            type: 'success',
            message: `修改成功`,
            onClose: () => {
                infoList()
            }
        })
    } else {
        ElMessage.error('修改失败!')
    }
}

let pageSize = ref(7)

const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    infoList()
}

const infoList = async () => {
    loading.value = true

    try {
        let data = {
            screenType: value.value[0],
            pageCount: pageCount.value,
            pageSize: pageSize.value,
            wordKey: wordKey.value
        }
        console.log(data)

        const res = await api.specTypeList(data)
        console.log(res)
        if (res.code == 401) {
            ElMessageBox.alert('登录已过期请重新登入！', '', {

                confirmButtonText: 'OK',
                callback: (action) => {
                    router.push({
                        path: '/login'
                    })
                },
            })
            // router.push('login')
        }
        if (res.data) {
            infolists.value = res.data.goodsSpecs

            total.value = (Math.ceil(res.data.total / pageSize.value))
            loading.value = false
            // console.log(res.data.members)
            // console.log(res.data.total)
        } else {
            loading.value = false

            infolists.value = []
        }

    } catch (error) {
        console.log(error)
    }
}
onMounted(() => {
    pageCount.value = 1
    infoList()
})
const wordkey = () => {
    wordKey.value = keyseach.value

    pageCount.value = 1
    infoList()
}

let pids = ref([])
const spec = (id) => {
    ElMessageBox.confirm('是否删除该规格？')
        .then(() => {
            detspec(id)
        })
        .catch(() => {
            // catch error
        })
}
const detspec = async (id) => {

    const res = await api.specTypedel(id)
    if (res.success) {
        ElMessage({
            message: '删除成功',
            type: 'success',
            onClose: () => {
                infoList()
            }
        })
    } else {
        ElMessage({
            message: '删除失败',
            type: 'warning',

        })
    }

}

const handleChange = (value) => {
    console.log(value)
    screenType.value = value[0]
}
const gomessage = (item, type) => {
    router.push({
        path: '/home/standard/standerdmsg',
        query: {
            id: item.id,
            storeId: item.storeId,
            name: item.typeName,
            type: type
        }
    })

}





//跳转页面
const changepige = (val) => {

    pageCount.value = val
    infoList()

}

</script>

<style lang="scss" scoped>
::v-deep .el-checkbox {


    // height: 100%;

    .el-checkbox__input {
        height: 20px;

        .el-checkbox__inner {
            width: 20px;
            height: 20px;
            border-radius: 10px;
        }

        .el-checkbox__inner {
            &::after {
                top: 4px;
                left: 8px;
            }

        }
    }
}

::v-deep .choosedatas {
    width: 100%;
    height: 100%;
    background-color: #FAFAFA;
    --el-input-border-color: transparent;
    cursor: pointer;

    input {
        font-size: 16px;
        color: #718096;
        cursor: pointer;
    }

}

::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #FAFAFA !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

    ::placeholder {
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }

}

::v-deep .example-pagination-block {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    // .el-pager{
    //     display: none;
    // }

    .is-active {
        background-color: #FAFAFA !important;
        color: #1787FF !important;
        border-radius: 8px;
    }

}

::v-deep .example-pagination-iskey {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .el-pager {
        display: none;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }
}


.vtext {
    height: 50px;
    font-size: 32px;
    font-weight: 400;
    color: #0A1629;
    line-height: 50px;
}

.viplist {
    position: relative;
    margin-top: 25px;
    height: calc(100% - 85px);
    min-width: 1166px;
    // min-height: 662px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;

    .pagechoose {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 70px;
        padding-left: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .pagees {
            width: 71px;
            height: 40px;
            border: 1px solid #EEEFF2;
            border-radius: 8px;
            padding: 8px 0 0 0px;
            box-sizing: border-box;

            input {
                width: 80%;


            }
        }
    }

    .vipporpe {
        width: 100%;
        // padding-left: 15px;
        box-sizing: border-box;



        table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            padding: 0;
            margin: 0;

            thead {
                width: 100%;
                height: 46px;
                text-align: left;
                display: table-header-group;
                font-size: 14px;
                font-weight: 400;
                color: #4D585F;
                border-bottom: 1px solid #EEEFF2;

                th {
                    vertical-align: middle;
                }

                th:first-child {
                    padding-left: 15px;

                }

                .states {
                    text-align: center;
                }
            }

            tbody {
                tr {

                    height: 71px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #000000;
                    border-bottom: 1px solid #EEEFF2;


                    td:first-child {
                        padding-left: 15px;

                    }

                    td:last-child {
                        width: 66px;
                        padding-right: 9px;

                        .operate {
                            width: 200px;

                            color: #1787FF;
                            font-weight: 400;
                            font-size: 12px;
                            display: flex;
                            justify-content: space-between;


                        }
                    }

                    td {

                        vertical-align: middle;

                        .statea {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .state {
                                width: 66px;
                                height: 36px;
                                background: #EBF3FF;
                                border-radius: 4px;
                                text-align: center;
                                line-height: 36px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #1787FF;
                            }

                            .state2 {
                                width: 66px;
                                height: 36px;
                                background: rgb(252, 241, 231);
                                border-radius: 4px;
                                text-align: center;
                                line-height: 36px;
                                font-size: 14px;
                                font-weight: 400;
                                color: rgb(243, 182, 133);
                            }
                        }


                    }


                }

                tr:hover {
                    background-color: #f3f3f3;
                }
            }

        }
    }

    .vipt {
        padding-top: 17px;
        margin-left: 15px;
        display: flex;

        .screen {
            width: 168px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;
            margin-right: 24px;
        }

        .search {
            width: 412px;
            height: 48px;
            margin-right: 14px;
            background: #FAFAFA;
            // box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
            border-radius: 8px;
            display: flex;
            align-items: center;
            padding-left: 20px;
            box-sizing: border-box;

            input {
                width: 300px;
                border: none;
                outline: none;
                font-size: 16px;
                background: #FAFAFA;

            }

            ::placeholder {
                font-weight: 400;
                font-size: 14px;
                color: #7D8592;
            }

        }

        .calendar {
            width: 168px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;



        }

        .exdown {
            width: 101px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;
            margin-left: 31px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #718096;
            cursor: pointer;


            img {
                width: 17px;
                height: 21px;
            }
        }

    }
}

.dialog {
    position: relative;
    width: 500px;
    height: 608px;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
        padding: 23px 36px 0 35px;
    }

    .exchooses {
        padding: 23px 36px 0 35px;
        height: 400px;
        overflow: auto;

        .exchoosee {
            display: flex;
            height: 38px;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            color: #111827;
            align-items: center;
            margin-top: 13px;
        }
    }

    .downex {
        .dowm {
            width: 121px;
            height: 51px;
            background: #3686FF;
            border-radius: 8px;
            text-align: center;
            line-height: 51px;
            font-size: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }

        display: flex;
        align-items: center;
        justify-content: center;
        width: 500px;
        height: 120px;
        background: #F2F8FC;

    }

}
</style>